export default "__VITE_ASSET__C4a6wJ4l__"